import { Injectable } from '@angular/core';

@Injectable()
export class StatisticsService {
  constructor() {}

  addStatisticToArray(array: Statistic[], label: string, value: number, type?: string) {
    const stat: Statistic = {
      label,
      value,
      type,
    };

    array.push(stat);
  }
}

export interface Statistic {
  label: string;
  value: number;
  type?: string;
}
